"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Button_default
} from "./chunk-WBZIOSC6.mjs";

// src/components/sections/CardBanner/CardBanner.tsx
import { forwardRef } from "react";
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
var CardBanner = forwardRef(
  function CardBanner2({
    title,
    tag,
    description,
    reverse = false,
    buttons,
    images,
    backgroundColor = "bg-display-100",
    imageBorder = true,
    className,
    unlimitedImageSize
  }, ref) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "flex justify-center py-40 lg:py-80 px-16 md:px-24 w-full",
        ref,
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${(className != null ? className : reverse) ? "flex flex-col md:flex-row-reverse" : "flex flex-col md:flex-row"} ${backgroundColor}  lg:grid-cols-2 md:gap-24 lg:gap-40 justify-center items-center md:p-24 lg:p-40 px-12 pt-12 pb-16 w-full max-w-[455px] md:max-w-[1060px] md:min-h-[294px] lg:min-h-[318px] rounded-2xl md:rounded-6xl lg:rounded-6xl`,
            children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: `flex overflow-hidden relative order-1 md:order-2 w-full max-w-[470px] md:max-w-[485px] min-h-[197px] ${imageBorder && "rounded-2xl rounded-bl-none"}`,
                  children: [
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: classNames("hidden lg:block", {
                          "h-[212px] lg:h-[248px]": unlimitedImageSize
                        }),
                        children: /* @__PURE__ */ jsx(
                          Image_default,
                          {
                            src: images.mobile.path || images.web.path,
                            alt: images.mobile.alternativeText || images.web.alternativeText,
                            layout: "fill",
                            className: "object-cover"
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ jsx("div", { className: "hidden lg:block rounded-2xl", children: /* @__PURE__ */ jsx(
                      Image_default,
                      {
                        src: images.web.path,
                        alt: images.web.alternativeText,
                        className: "object-cover",
                        layout: "fill"
                      }
                    ) }),
                    /* @__PURE__ */ jsx("div", { className: "hidden md:block lg:hidden w-[357px] h-[248px]", children: /* @__PURE__ */ jsx(
                      Image_default,
                      {
                        src: images.tablet.path || images.web.path,
                        alt: images.tablet.alternativeText || images.web.alternativeText,
                        layout: "fill",
                        className: "object-cover"
                      }
                    ) })
                  ]
                }
              ),
              /* @__PURE__ */ jsxs("div", { className: "flex flex-col order-2 md:order-1 px-4 md:px-0 mt-24 md:mt-0 w-full md:min-w-[315px] md:max-w-[455px] lg:max-w-none", children: [
                tag && /* @__PURE__ */ jsx(
                  "p",
                  {
                    className: "py-4 px-8 mb-8 w-max font-semibold leading-4 text-stone-800 bg-stone-200 rounded-lg text-base",
                    dangerouslySetInnerHTML: { __html: tag }
                  }
                ),
                title && /* @__PURE__ */ jsx(
                  "h2",
                  {
                    className: "font-display text-3xl lg:text-4xl font-bold leading-7 lg:leading-8",
                    dangerouslySetInnerHTML: { __html: title }
                  }
                ),
                description && /* @__PURE__ */ jsx(
                  "p",
                  {
                    className: "text-base lg:text-lg leading-4 lg:leading-5  pt-8 pb-24",
                    dangerouslySetInnerHTML: {
                      __html: description
                    }
                  }
                ),
                !!(buttons == null ? void 0 : buttons.length) && /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: `flex ${reverse != null ? reverse : "flex-row-reverse"} gap-16 flex-wrap w-full lg:flex-nowrap`,
                    children: buttons == null ? void 0 : buttons.map((buttonProps, index) => /* @__PURE__ */ jsx(
                      Button_default,
                      {
                        className: "w-full md:w-full lg:w-max",
                        ...buttonProps
                      },
                      index
                    ))
                  }
                )
              ] })
            ]
          }
        )
      }
    );
  }
);
var CardBanner_default = CardBanner;

export {
  CardBanner_default
};
